import { render, staticRenderFns } from "./TabelaProdutos.vue?vue&type=template&id=49cee798&scoped=true"
import script from "./TabelaProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaProdutos.vue?vue&type=script&lang=js"
import style0 from "./TabelaProdutos.vue?vue&type=style&index=0&id=49cee798&prod&scoped=true&lang=css"
import style1 from "./TabelaProdutos.vue?vue&type=style&index=1&id=49cee798&prod&lang=css"
import style2 from "./TabelaProdutos.vue?vue&type=style&index=2&id=49cee798&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cee798",
  null
  
)

export default component.exports